/**
 * Single source of truth for the user-facing app version.
 *
 * Bump this string on every release where you want:
 *   1. Users who previously dismissed the "Install" banner to see it again
 *      (so a returning user finds out about the new feature you just shipped).
 *   2. Installed PWA users to see the "Update available — Reload" banner
 *      with a confident version label.
 *
 * Keep loosely in sync with `CACHE_NAME` in `public/service-worker.js`, but
 * they don't have to match exactly. `CACHE_NAME` controls *offline cache
 * invalidation*; this constant controls *user-facing nudge prompts*.
 *
 * Format suggestion: `YYYY.MM.DD` (sortable, human-readable, no SemVer
 * decisions). Anything that strict-equality-changes works.
 */
export const APP_VERSION = '2026.08.26';
